<template>
  <b-row>
    <b-col cols="12">
      <slide-content />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import SlideContent from './SlideContent.vue'

export default {
  components: {
    BRow,
    BCol,

    SlideContent
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>